import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container, Hidden } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const DESTINATION_TYPES = {
  'todos': 'all',
  'nacional': 'national',
  'internacional': 'international'
}

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  const isDepositOrTransfer = () => {
    return record.card_relation?.long_name === 'Deposito' || record.card_relation?.long_name === 'Transferencia'
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={translate('ra.entity.installment')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.product_type')} value={record.product_name} />
          <ShowListElement
            label={translate('ra.field.destination_type')}
            value={!record.type_air || translate(`ra.destination_type.${DESTINATION_TYPES[record.type_air?.toLowerCase()]}`).includes('.')
              ? record.type_air
              : translate(`ra.destination_type.${DESTINATION_TYPES[record.type_air?.toLowerCase()]}`).toUpperCase()
            }
          />
          <ShowListElement label={translate('ra.field.is_active')} value={record.is_active} type='boolean' />
          <ShowListElement label={translate('ra.field.work_unit')} value={record.work_unit_name} />
          <ShowListElement label={translate('ra.field.source')} value={record.source_relation?.long_name} />
          <ShowListElement
            label={`${translate('ra.field.company')} (${translate('ra.field.business')})`}
            value={record.company_relation?.long_name}
          />
          <ShowListElement label={translate('ra.field.card')} value={record.card_relation?.long_name} />
          {isDepositOrTransfer() ? (
            <Hidden smDown><Grid item md={4} /></Hidden>
          ) : (
            <>
              <ShowListElement
                label={translate('ra.field.card_type')}
                value={!record.type || translate(`ra.card_type.${record.type.toLowerCase()}`).includes('.')
                  ? record.type
                  : translate(`ra.card_type.${record.type.toLowerCase()}`).toUpperCase()
                }
              />
              <ShowListElement label={translate('ra.field.gateway')} value={record.gateway_relation?.name} />
            </>
          )}
          <ShowListElement label={`${translate('ra.field.site_label')} (${translate('ra.field.gds')})`} value={record.gds} />
          <ShowListElement label={translate('ra.field.order')} value={record.order} />
          {isDepositOrTransfer() && <Hidden smDown><Grid item md={4} /></Hidden>}
          <ShowListElement label={translate('ra.field.start_validity')} value={record.date_start} type='date' includeTime />
          <ShowListElement label={translate('ra.field.end_validity')} value={record.date_validity} type='date' includeTime />
          <ShowListElement label={translate('ra.field.last_update')} value={record.updated_at} type='date' includeTime />
          <ShowListElement label={translate('ra.field.include_route')} value={record.include_route} />
          <ShowListElement label={translate('ra.field.exclude_route')} value={record.exclude_route} />
          <Hidden smDown><Grid item md={4} /></Hidden>
          <ShowListElement label={translate('ra.field.exclude_airlines')} value={record.exclude_airline} />
          <ShowListElement label={translate('ra.field.only_airline')} value={record.only_airline} type='boolean' />

          <Grid container item xs={12} className='installment-extra-data-container-show'>
            <ShowListElement label={translate('ra.field.bank')} value={record.financial_entity_relation?.long_name} />
            <ShowListElement label={translate('ra.field.installments')} value={record.quota} />
            <Hidden smDown><Grid item md={4} /></Hidden>
            <ShowListElement label={translate('ra.field.coef')} value={record.coef} />
            <ShowListElement label={translate('ra.field.expense')} value={record.gasto} />
            <ShowListElement label={`${translate('ra.field.unifyCoef')} (unifycoef)`} value={record.unify_coef} type='booblean' />
            <ShowListElement sm={8} label={translate('ra.field.bines')} value={record.bines} />
            <Hidden smDown><Grid item md={4} /></Hidden>
            <ShowListElement label={translate('ra.field.cft')} value={record.cft} />
            <ShowListElement label={translate('ra.field.tea')} value={record.tea} />
            <Hidden smDown><Grid item md={4} /></Hidden>
            <ShowListElement label={translate('ra.field.refund')} value={record.refund} />
            <ShowListElement label={translate('ra.field.bonus')} value={record.bonus} />
          </Grid>
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const InstallmentShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
